import React from 'react';
import Chip from '@material-ui/core/Chip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  chip: {
    height: 24,
    fontSize: 12,
    fontWeight: 'bold',
    borderRadius: 12,
    padding: '0 12px',
    backgroundColor: '#F5F5F7',
    color: theme.palette.text.secondary,
  },
  external: {
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.common.white,
  },
}));

const TypeField = (props) => {
  const { record } = props;

  const classes = useStyles();
  const isInternal = Boolean(record?.type);

  return (
    <Chip
      className={classNames(classes.chip, { [classes.external]: !isInternal })}
      label={isInternal ? 'Internal' : 'External'}
      size="small"
    />
  );
};

export default TypeField;
